import { render } from "./help.vue?vue&type=template&id=74820f26&scoped=true"
import script from "./help.vue?vue&type=script&lang=js"
export * from "./help.vue?vue&type=script&lang=js"

import "./help.vue?vue&type=style&index=0&id=74820f26&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74820f26"]])

export default __exports__